import React from "react";
import { Route } from "react-router-dom";

import BRSession08 from "../blade-runner/BRSession08";
import BRSession07 from "../blade-runner/BRSession07";
import BRSession06 from "../blade-runner/BRSession06";
import BRSession05 from "../blade-runner/BRSession05";
import BRSession04 from "../blade-runner/BRSession04";
import BRSession03 from "../blade-runner/BRSession03";
import BRSession02 from "../blade-runner/BRSession02";
import BRSession01 from "../blade-runner/BRSession01";
import BRSession00 from "../blade-runner/BRSession00";

const BladerunnerRoutes = () => {
  return [
    <Route path="/blade-runner-session-08" element={<BRSession08 />} />,
    <Route path="/blade-runner-session-07" element={<BRSession07 />} />,
    <Route path="/blade-runner-session-06" element={<BRSession06 />} />,
    <Route path="/blade-runner-session-05" element={<BRSession05 />} />,
    <Route path="/blade-runner-session-04" element={<BRSession04 />} />,
    <Route path="/blade-runner-session-03" element={<BRSession03 />} />,
    <Route path="/blade-runner-session-02" element={<BRSession02 />} />,
    <Route path="/blade-runner-session-01" element={<BRSession01 />} />,
    <Route path="/blade-runner-session-00" element={<BRSession00 />} />,
  ];
};

export default BladerunnerRoutes;
